import type { Command } from 'commander';
import { Logger } from '@gitlab-org/logging';
import { MarketplaceRegistry } from '@gitlab-org/duo-plugin-marketplace/node';
import type { DuoCommand } from '../../duo_command';
import { ExitHandler } from '../../../utils/exit';
import type { PluginContainerProvider } from '../plugin_services';

export class MarketplaceRemoveCommand implements DuoCommand {
  readonly name = 'remove <name>';

  readonly description = 'Remove a plugin marketplace and uninstall its plugins.';

  readonly #containerProvider: PluginContainerProvider;

  constructor(containerProvider: PluginContainerProvider) {
    this.#containerProvider = containerProvider;
  }

  register(node: Command): void {
    node.action(async (name: string) => {
      const registry = this.#containerProvider.getRequiredService(MarketplaceRegistry, node);

      try {
        await registry.remove(name);
        // eslint-disable-next-line no-console
        console.log(`Removed marketplace: ${name}`);
      } catch (e) {
        const logger = this.#containerProvider.getRequiredService(Logger, node);
        logger.error('Failed to remove marketplace', e instanceof Error ? e : new Error(String(e)));
        const message = e instanceof Error ? e.message : String(e);
        // eslint-disable-next-line no-console
        console.error(`Failed to remove marketplace: ${message}`);
        await this.#containerProvider.getRequiredService(ExitHandler, node).exit(1);
      }
    });
  }
}
